import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { DriverRideSharingService } from './driver-ride-sharing-service';
import { Person } from './person';
import { Vehicle } from './vehicle';

@inheritSerialization(Person)
export class Driver extends Person {
  @autoserialize
  dotsDriverIdentifier: number;

  /**
   * @deprecated
   *
   * @type {Array<DriverRideSharingService>}
   * @memberof Driver
   */
  @autoserializeAs(DriverRideSharingService)
  driverRideSharingServices: Array<DriverRideSharingService>;

  @autoserializeAs(Vehicle)
  vehicles: Array<Vehicle>;
}
